// 统计分析
export default [
  {
    path: "CloudProduct",
    name: "CloudProduct",
    component: () =>
      import(
        "@/views/Home/StatisticalAnalysis/CloudWarehouseReport/CloudProduct"
      ),
    meta: {
      title: "云仓商品库存统计",
    },
  },
  {
    path: "CloudWarehouse",
    name: "CloudWarehouse",
    component: () =>
      import(
        "@/views/Home/StatisticalAnalysis/CloudWarehouseReport/CloudWarehouse"
      ),
    meta: {
      title: "云仓仓库库存统计",
    },
  },
];
